import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CurrencyModel } from './currency.model'
import { environment } from '../../../../environments/environment'
import { catchError, map, Observable } from 'rxjs'

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(private http: HttpClient) {}

  addCurrency(currency: CurrencyModel) {
    
    return this.http.post(API_URL + '/Currency/CreateCurrency', currency, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateCurrency(currency: CurrencyModel) {
    
    return this.http.put(API_URL + '/Currency/UpdateCurrency', currency, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllCurrencies(): Observable<CurrencyModel[]> {
    return this.http.get(API_URL + '/Currency/ReadCurrencies', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deleteCurrency(currency: CurrencyModel) {
    
    return this.http
      .delete(API_URL + '/Currency/DeleteCurrency', {
        headers: {},
        body: currency,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
